import React from 'react';

import { Skeleton, Text } from '@/nova/components';

import * as S from './LibrarySkeletonCards.styles';

export interface LibrarySkeletonCardsProps {
  /** Translated. What is loading (e.g. "Loading your image banners…"), read out by assistive tech. */
  label: string;
  /** A card footer's own skeleton (e.g. the stats row), so each card is as tall as the card it becomes. */
  footer?: React.ReactNode;
  /** How many cards (with the "create new" tile, three fill a desktop row). */
  count?: number;
}

/**
 * A library grid's cards while its list loads: placed in the grid after the "create new" tile, one skeleton per slot of
 * a real card (poster, name, meta and actions row, footer). The grid shows these until the brand's final list has
 * landed, never an empty grid that fills in.
 */
export const LibrarySkeletonCards = ({ label, footer, count = 3 }: LibrarySkeletonCardsProps): React.ReactElement => (
  <>
    <S.SrOnly role="status">
      <Text raw tag="span" text={label} />
    </S.SrOnly>
    {Array.from({ length: count }, (_v, i) => (
      <S.SavedCard key={i} aria-hidden="true">
        <S.PosterSlot as="div">
          <Skeleton block width="100%" height="100%" radius={0} />
        </S.PosterSlot>
        <S.SavedBody>
          <S.Line $size={14}>
            <Skeleton width="62%" height="1em" />
          </S.Line>
          <S.SavedFoot>
            <S.Line $size={11}>
              <Skeleton width={72} height="1em" />
            </S.Line>
            <S.ActionSlot />
          </S.SavedFoot>
          {footer}
        </S.SavedBody>
      </S.SavedCard>
    ))}
  </>
);

export default LibrarySkeletonCards;
